import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import type { GiteaRepoSummary } from "@/types";

// #215 (E2): Gitea-Browse für die Seed-Auswahl (Profil + späterer Agent-Flash).

export function useGiteaRepos(): UseQueryResult<GiteaRepoSummary[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["gitea", "repos"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<GiteaRepoSummary[]>("/gitea/repos");
    },
    enabled: !!session,
  });
}

export function useGiteaBranches(repoFullName: string | null): UseQueryResult<string[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["gitea", "branches", repoFullName ?? "_none"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      const [owner, repo] = (repoFullName ?? "").split("/");
      return client.get<string[]>(
        `/gitea/repos/${encodeURIComponent(owner)}/${encodeURIComponent(repo)}/branches`,
      );
    },
    enabled: !!session && !!repoFullName,
  });
}
